import React from "react";

import { connect } from "react-redux";

import type { BusbudError } from "@busbud/busbud-errors";

import type { ErrorModalButtonType } from "@app/helpers/api-error";
import { useAppContext } from "@app/helpers/hooks";
import type { CheckoutCartProp } from "@app/types/checkout-redux-types";
import type { ResultsReduxState } from "@app/types/results-redux-types";

import { useStyles } from "./departure-changed.styles";
import * as ErrorTracking from "../../../tracking/error-tracking";
import { AlertDialog } from "../../alert-dialog";

interface OwnProps {
  error: BusbudError | null;
  onDismiss?: () => void;
}

interface ReduxProps {
  cart: CheckoutCartProp;
}

const DepartureChanged: React.FC<OwnProps & ReduxProps> = ({ onDismiss }) => {
  const { tracker, translator } = useAppContext();
  const { classes } = useStyles();

  const buttons = {
    primary_button: {
      label: "Continue browsing",
      props: {
        "data-cy": "departure-changed-modal-confirm"
      }
    }
  };

  const onAction = (button_type: ErrorModalButtonType) => {
    tracker.track(ErrorTracking.clickedErrorButton(button_type));

    onDismiss?.();
  };

  return (
    <AlertDialog
      classes={{
        title: classes.title
      }}
      classnames_override={{
        message: "text-center"
      }}
      title={translator.t("!checkout.departure-changed-modal.title")}
      message={translator.t("!checkout.departure-changed-modal.message")}
      actionHandler={onAction}
      {...buttons}
    />
  );
};

const DepartureChangedComponent = connect<
  ReduxProps,
  {},
  OwnProps,
  ResultsReduxState
>(null)(DepartureChanged);

export { DepartureChangedComponent as DepartureChanged };
